import { IAjaxConfig } from '../libraries';
export class EnumApiAccountsvr {
  /**
   * @dec 获取图片验证码
   * @method post
   */
  readonly accountsvr_imgCode: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/imgCode',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec lenovoId获取图片验证码
   * @method post
   */
  readonly accountsvr_imgCode_lid: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/lenovo-id/imgCode',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 发送短信验证码(登录状态下)
   * @method post
   */
  readonly accountsvr_SendCode: IAjaxConfig = {
    // 测试用
    //  url: '/api/gateway/idaas/v1/notification/verification-code/get',
    url: '/api/gateway/idaas/v1/notification/verification-code/send',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 发送短信验证码(未登录状态下)
   * @method post
   */
  readonly accountsvr_SendCode_unLogin: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/notification/verification-code/send',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 注册返回code
   * @method post
   */
  readonly accountsvr_user_add: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/users/add',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 注册code登录
   * @method post
   */
  readonly accountsvr_user_add_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/register/code/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec 手机号登录
   * @method post
   */
  readonly accountsvr_sms_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/sms/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 账号密码登录
   * @method post
   */
  readonly accountsvr_account_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/pwd/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 根据appSourceId获取app基本信息
   */
  readonly accountsvr_app_base_info: IAjaxConfig = {
    url: '/api/gateway/idaas/public/app/config/get',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 根据账号查询基本信息
   */
  readonly accountsvr_account_get_info: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/account/forget/pwd/info/get',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 找回密码
   */
  readonly accountsvr_retrieve_pwd: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/account/mobile/forget/pwd',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 根据idToken获取用户信息
   */
  readonly accountsvr_token_get_info: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/users/user/info/get',
    method: 'get',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 用户绑定手机号
   */
  readonly accountsvr_bind_mobile: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/users/user/mobile/bind',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 校验验证码
   */
  readonly accountsvr_check_code: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/notification/verification-code/check',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 修改密码
   */
  readonly accountsvr_edit_pwd: IAjaxConfig = {
    url: '/api/gateway/idaas/lenovo/update/pwd',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 12位01码邮箱找回密码
   */
  readonly accountsvr_email_retrieve: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/account/twelve/forget/pwd',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 12位01码修改密码
   */
  readonly accountsvr_reset_pwd: IAjaxConfig = {
    url: '/api/gateway/idaas/lenovo/update/pwd',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 中台系统用户名密码登录
   * @method post
   */
  readonly accountsvr_middle_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/tenant/pwd/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 账号登录修改密码(密码强度过低的情况下)
   */
  readonly accountsvr_account_login_update_pwd: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/account/login/update/pwd',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };
  /**
   * @dec lenovoid单点登录检查登录状态
   */
  readonly accountsvr_lenovoid_check_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/lenovo/login/check',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec lenovoid单点登录checkcode登录
   */
  readonly accountsvr_lenovoid_checkcode_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/lenovo/check/code/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec lenovoid单点登录checkcode注册
   */
  readonly accountsvr_lenovoid_checkcode_register: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/lenovo/check/code/register',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec lenovoid单点登录-注册登录
   */
  readonly accountsvr_lenovoid_register_login: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/authorization/register/code/login',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 切换登录身份
   */
  readonly accountsvr_identity_switch: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/identity/switch',
    method: 'post',
    loading: true,
    awaitAuthenticated: false,
  };

  /**
   * @dec 退出登录
   */
  readonly accountsvr_loginout: IAjaxConfig = {
    url: '/api/gateway/idaas/v1/token/invalid',
    method: 'put',
  };

  /**
   * @dec 校验合法域名
   */
  readonly accountsvr_check_domain: IAjaxConfig = {
    url: '/api/gateway/idaas/app/domain/verify',
    method: 'post',
  };

  /**
   * @dec 窗口期，安全手机绑定，发送短信验证码，
   * @method post
   */
  readonly accountsvr_security_SendCode: IAjaxConfig = {
    url: '/api/gateway/idaas/lenovo/bind/mobile/sms/send',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 窗口期，安全手机绑定，绑定手机号
   * @method post
   */
  readonly accountsvr_security_bindmobile: IAjaxConfig = {
    url: '/api/gateway/idaas/lenovo/bind/mobile',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 窗口期，安全手机绑定，绑定手机号
   * @method post
   */
  readonly accountsvr_ignore_bindmobile: IAjaxConfig = {
    url: '/api/gateway/idaas/lenovo/ignore/bind/mobile',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 忘记密码/重置密码，根据账号查询基本信息
   */
  readonly accountsvr_account_pwd_get_info: IAjaxConfig = {
    url: '/api/gateway/idaas/public/lenovo/forget/pwd/info/get',
    method: 'get',
    loading: true,
  };

  /**
   * @dec 忘记密码/重置密码，发送短信验证码，
   * @method post
   */
  readonly accountsvr_pwd_SendCode: IAjaxConfig = {
    url: '/api/gateway/idaas/public/lenovo/forget/pwd/send',
    method: 'post',
    loading: true,
  };

  /**
   * @dec 忘记/重置密码
   */
  readonly accountsvr_forget_pwd: IAjaxConfig = {
    url: '/api/gateway/idaas/public/lenovo/forget/pwd',
    method: 'post',
    loading: true,
  };
  /**
   * @dec 获取临时token
   */
  readonly accountsvr_tem_token: IAjaxConfig = {
    url: '/api/gateway/idaas/public/v1/tem/token',
    method: 'get',
  };
}
